import Invoice5Container from "../../../../components/applications/eCommerce/invoices/invoice5";

const Invoice5 = () => {
  return <Invoice5Container />;
};

export default Invoice5;
